import { useMemo } from 'react';
import { ENDPOINTS } from '../../endpoints';
import { Service } from '../base';
import dynamicAxios from '../../utils/axios';

import useServices from '../../hooks/useServices';
import { SocialLogin } from './types';

class ServiceAccounts extends Service {
  loginGoogle({ access_token }: { access_token: string }) {
    return this.axiosInstance.post<SocialLogin>(ENDPOINTS.socialAuth.google, { access_token });
  }

  loginFacebook({ accessToken }: { accessToken: string }) {
    return this.axiosInstance.post<SocialLogin>(ENDPOINTS.socialAuth.facebook, { access_token: accessToken });
  }
}

export function useSocialAuthService() {
  const { baseUrl, jwt } = useServices();
  return useMemo(() => new ServiceAccounts(dynamicAxios(baseUrl, jwt)), [baseUrl, jwt]);
}

export default useSocialAuthService;

export * from './types';
